import { FC } from 'react';
import {
  Box,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';

import { ReadonlyForm } from 'components/molecules/ReadonlyForm';

export type Props = {
  mode: '登録' | '更新';
  isOpen: boolean;
  contractId?: number | undefined;
  menuName: string;
  displayValid?: string;
  displayStartDate: string;
  displayEndDate: string;
  handleClose: () => void;
  handleClickGoInput: () => void;
  handleClickExecution: () => void;
};

export const ContractConfirmationModalView: FC<Props> = ({
  mode,
  isOpen,
  contractId,
  menuName,
  displayValid,
  displayStartDate,
  displayEndDate,
  handleClose,
  handleClickGoInput,
  handleClickExecution,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={handleClose}
    size="2xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
    isCentered
  >
    <ModalOverlay />
    <ModalContent h="60vh" minH="750px">
      <ModalHeader p="40px 40px 0 40px">契約メニューの{mode}</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" p="0 40px 0 40px">
        {mode === '更新' && (
          <Box mt="40px">
            <ReadonlyForm
              label="契約 ID"
              value={contractId ? contractId.toString() : ''}
            />
          </Box>
        )}
        <Box mt="40px">
          <ReadonlyForm label="メニュー" value={menuName} />
        </Box>
        {mode === '更新' && (
          <Box mt="40px">
            <ReadonlyForm label="有効 / 無効" value={displayValid ?? ''} />
          </Box>
        )}
        <Box mt="40px">
          <ReadonlyForm label="契約開始日" value={displayStartDate} />
        </Box>
        <Box mt="40px">
          <ReadonlyForm label="契約終了日" value={displayEndDate} />
        </Box>
      </ModalBody>
      <ModalFooter justifyContent="center" mt="20px" mb="20px">
        <VStack>
          <Text fontSize="lg" textAlign="center">
            上記の内容で契約メニューを{mode}しますか？
          </Text>
          <Box h="20px" />
          <HStack>
            <Button
              colorScheme="gray"
              variant="outline"
              mr={3}
              onClick={handleClickGoInput}
            >
              入力画面へ戻る
            </Button>

            <Button
              width="140px"
              colorScheme="blackAlpha"
              mr={3}
              onClick={handleClickExecution}
            >
              {mode}
            </Button>
          </HStack>
        </VStack>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
